<app-organizer-shared-layout-funnel
  [class]="builtLayoutCssClass"
  [hasCloseButton]="hasCloseButton"
  [variant]="pageVariant"
  [ngStyle]="backgroundStyle"
>
  <app-organizer-shared-page-container>
    <app-stepper-title
      [stepsNumber]="stepsNumber"
      [active]="activeStep"
      [variant]="pageVariant"
    >
      <h1>{{ titleStepperKey | translate }}</h1>
    </app-stepper-title>

    <p [innerText]="descriptionKey | translate"></p>

    <app-organizer-shared-navigation-buttons
      nextQueryParametersHandling="preserve"
      previousQueryParametersHandling="preserve"
      [hasPreviousButton]="hasPreviousButton"
      [nextDisabled]="false"
      [nextLabel]="nextLabel"
      [variant]="pageVariant"
    ></app-organizer-shared-navigation-buttons>
  </app-organizer-shared-page-container>

  <app-beveled-picture
    layout-right-content
    class="organizer-shared-page-overview__picture"
    [src]="imageSource"
  ></app-beveled-picture>
</app-organizer-shared-layout-funnel>
